import { useState, useEffect } from 'react';

import { useNavigate, useLocation } from 'react-router-dom';
import {
    Table,
    TableHead,
    TableBody,
    TableRow,
    TableCell,
    TableContainer,
    Paper,
    Typography,
} from '@mui/material';
import { DateTime } from "luxon";
import { Box, Modal, Button } from '@mui/material';
import { Icon } from "@iconify/react";
import { toast } from "react-toastify";
import plusIcon from '@iconify/icons-mdi/eye-circle-outline';
import editIcon from '@iconify/icons-mdi/square-edit-outline';
import deleteIcon from '@iconify/icons-mdi/trash-can-outline';
import closeIcon from '@iconify/icons-mdi/close-circle-outline';
import "../../../styles/Auth/booking.css";
import getStatusStyle from "../../../utils/statusStyle.js";
import { getData, postData, deleteData, putData } from '../../../webService/webservice.js';
const BookingPage = ({ filters }) => {
    const navigate = useNavigate();
    const location = useLocation();
    const role = sessionStorage.getItem("role");
    const adminStoreIds = JSON.parse(sessionStorage.getItem("storeIds") || "[]");
    const initialStoreId = sessionStorage.getItem("currentStoreId") ||
        (role === "Admin" ? adminStoreIds[0] || "" : "");
    const commonCellStyle = {
        color: '#525252',
        fontSize: '12px',
        fontWeight: 600,
        textAlign: 'center'
    };
    const headings = [
        'SL',
        'Customer Name',
        'Booking time',
        'Location',
        'Total',
        'Status',
        'Action',
    ];
    const [searchQuery, setSearchQuery] = useState('');
    const [bookings, setBookings] = useState([]);
    const [isAddBooking, setIsAddBooking] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [editBookingId, setEditBookingId] = useState(null);
    const [open, setOpen] = useState(false);
    const [customers, setCustomers] = useState([]);
    const [services, setServices] = useState([]);
    const [stores, setStores] = useState([]);
    const [loading, setLoading] = useState(false);
    const [isPopupMode, setIsPopupMode] = useState(false);
    const [refreshKey, setRefreshKey] = useState(0);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [limit, setLimit] = useState(5);
    const [BookingToDelete, setBookingToDelete] = useState(null);
    const [totalCount, setTotalCount] = useState(0);
    const sessionToken = sessionStorage.getItem("Token");
    const [selectedStoreId, setSelectedStoreId] = useState(
        initialStoreId
    );
    const [formData, setFormData] = useState({
        customerId: "",
        serviceId: "",
        appointmentDate: "",
        timeSlot: "",
        status: "",
        remarks: "",
        storeId: initialStoreId,
    });
    const handleOpen = (bookingId) => {
        setBookingToDelete(bookingId);
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setBookingToDelete(null);
    };

    const triggerRefresh = () => {
        setRefreshKey(prev => prev + 1);
    };
    useEffect(() => {
        const fetchCustomers = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('customers/customers', {}, token);  // Adjust endpoint as needed
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setCustomers(results);
            } catch (error) {
                console.error("Failed to load customers", error);
            }
        };

        fetchCustomers();
    }, []);

    useEffect(() => {
        const fetchServices = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('services/services', {}, token);  // Adjust endpoint as needed
                console.log("API Full Response: ", data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setServices(results);
            } catch (error) {
                console.error("Failed to load services", error);
            }
        };

        fetchServices();
    }, []);

    useEffect(() => {
        const fetchStores = async () => {
            try {
                const token = sessionStorage.getItem("Token");
                const data = await getData('stores/stores', {}, token);
                console.log('API Full Response:', data);
                const results = data?.data?.[0]?.paginatedResults || [];
                setStores(results);

            } catch (error) {
                console.error("Failed to load sub categories", error);
            }
        };
        fetchStores();
    }, []);

    useEffect(() => {
        const storedStoreId = sessionStorage.getItem("storeId");
        if (storedStoreId && stores.length > 0) {
            const matchedStore = stores.find((store) => store._id === storedStoreId);
            if (matchedStore) {
                setFormData((prev) => ({
                    ...prev,
                    storeId: matchedStore._id,
                    storeName: matchedStore.storeName,
                }));
            }
        }
    }, [stores]);
    const handlePageChange = (direction) => {
        setCurrentPage((prev) =>
            direction === "next" ? Math.min(prev + 1, totalPages) : Math.max(prev - 1, 1)
        );
    };
    const handleItemsPerPageChange = (e) => {
        const value = e.target.value;
        const newLimit = value === "all" ? "all" : Number(value);
        setLimit(newLimit);
        setCurrentPage(1);
    };
    const handleAddBooking = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const token = sessionStorage.getItem("Token");

            // Build the full image URL
            const bookingData = {
                storeId: formData.storeId,
                serviceId: formData.serviceId,
                customerId: formData.customerId,
                appointmentDate: formData.appointmentDate,
                timeSlot: formData.timeSlot,
                remarks: formData.remarks,
                status: formData.status
            };
            console.log("Sending Booking data:", bookingData);

            const response = await postData('appointmentbookings/', bookingData, token);

            toast.success(response.message || 'Booking added successfully');
            setFormData({
                customerId: "",
                serviceId: "",
                appointmentDate: "",
                timeSlot: "",
                status: "",
                remarks: "",
            });
            setIsAddBooking(false);
            triggerRefresh();
            await new Promise((res) => setTimeout(res, 2000));

            alert(isEditMode ? "Booking Updated ✅" : "Booking Added ✅");
        } catch (error) {
            console.error('Add Product Error:', error);
            toast.error(error.message || 'Add Product Failed');
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchBookings(currentPage, limit, searchQuery, filters, selectedStoreId);
    }, [currentPage, limit, refreshKey, searchQuery, filters, selectedStoreId]);

    const fetchBookings = async (page, limit, searchQuery, filters) => {
        const params = {
            page,
            limit,
            search: searchQuery || "",
            status: filters.status || "",
            customerId: filters.customerId || "",
            sortBy: filters.sortBy || "",
            startDate: filters.startDate || "",
            endDate: filters.endDate || "",
        };
        if (selectedStoreId) params.storeId = selectedStoreId;
        try {
            setLoading(true);
            const response = await getData('appointmentbookings/appointmentbookings', params, sessionToken); // Your API route
            const resultsWrapper = response?.data?.[0];
            const bookingList = resultsWrapper?.paginatedResults || [];
            const totalCount = resultsWrapper?.totalCount || 0;
            const totalPages = resultsWrapper?.totalPages || 1;

            setBookings(bookingList);
            setTotalCount(totalCount);
            setTotalPages(totalPages);
        } catch (error) {
            toast.error(error.message || "Failed to fetch Booking");
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        setCurrentPage(1);
    }, [filters]);
    const handleUpdateBooking = async (e) => {
        e.preventDefault();
        setLoading(true);
        const appointmentDateISO = new Date(formData.appointmentDate).toISOString();
        const timeSlotISO = new Date(
            `${formData.appointmentDate}T${formData.timeSlot}`
        ).toISOString();
        try {
            const token = sessionStorage.getItem("Token");
            const updatedBookingData = {
                storeId: formData.storeId,
                serviceId: formData.serviceId,
                customerId: formData.customerId,
                appointmentDate: appointmentDateISO,
                timeSlot: timeSlotISO,
                remarks: formData.remarks,
                status: formData.status || "Pending"
            };

            console.log("Updating Booking with data:", updatedBookingData);

            const response = await putData(`appointmentbookings/appointmentbooking/${editBookingId}`, updatedBookingData, token);

            toast.success(response.message || 'Booking updated successfully');

            // Step 4: Reset form and close modal
            setFormData({
                customerId: "",
                serviceId: "",
                appointmentDate: "",
                timeSlot: "",
                status: "Pending",
                remarks: "",
            });
            setIsEditMode(false);
            setIsPopupMode(false)
            await fetchBookings(currentPage, limit);
            triggerRefresh();
            navigate('/bookings');
        } catch (error) {
            toast.error("Error updating Booking.");
        }
    };
    const modalStyle = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 400,
        bgcolor: '#F7EAE2',
        borderRadius: 12,
        boxShadow: 24,
        p: 4,
        border: 0
    };
    const handleDeleteBooking = async (e) => {
        e.preventDefault();
        try {
            const token = sessionStorage.getItem('Token');
            const response = await deleteData(`appointmentbookings/appointmentbooking/${BookingToDelete}`, token);
            toast.success(response.message || "Booking deleted successfully");
            setBookingToDelete(null);
            fetchBookings(currentPage, limit);
            handleClose();
            triggerRefresh();
        } catch (error) {
            console.error("Delete error:", error);
            toast.error(error.message || "Failed to delete Booking");
        }
    }

    useEffect(() => {
        const handleStoreChange = () => {
            const storeId = sessionStorage.getItem("currentStoreId");
            setSelectedStoreId(storeId);
            setCurrentPage(1);
        };

        window.addEventListener("storeChanged", handleStoreChange);
        return () => window.removeEventListener("storeChanged", handleStoreChange);
    }, []);

    return (
        <div className='booking-layout1'>
            <div className='booking-content1'>
                <main className='booking-main1'>
                    {isAddBooking ? (
                        <div className='add-Booking-form'>
                            <h3>Add Booking</h3>
                            <div className='booking-form-container'>
                                {loading && <div className="form-blocker"></div>}
                                <form className='Booking-form'>
                                    <div className='Booking-form-row'>
                                        <div className='booking-form-group'>
                                            <label htmlFor="title" className="input-label">
                                                Customer Name
                                            </label>
                                            <select
                                                id="customerId"
                                                className="booking-input"
                                                required
                                                value={formData.customerId}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, customerId: e.target.value }))
                                                }
                                                disabled={loading}
                                            >
                                                <option value="">Select Customer</option>
                                                {customers.map((cus) => (
                                                    <option key={cus._id} value={cus._id}>
                                                        {cus.name}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className='booking-form-group'>
                                            <label htmlFor="title" className="input-label">
                                                Service Name
                                            </label>
                                            <select
                                                id="serviceId"
                                                className="booking-input"
                                                required
                                                value={formData.serviceId}
                                                disabled={!formData.customerId || loading}
                                                onChange={(e) =>
                                                    setFormData((prev) => ({ ...prev, serviceId: e.target.value }))
                                                }
                                            >
                                                <option value="">Select Service</option>
                                                {services.map((ser) => (
                                                    <option key={ser._id} value={ser._id}>
                                                        {ser.serviceName}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="booking-form-group">
                                            <label className="input-label">Branch Name</label>
                                            <select
                                                className="category-input"
                                                value={formData.storeId || ""}
                                                onChange={(e) => {
                                                    const storeId = e.target.value;
                                                    setSelectedStoreId(storeId);
                                                    setFormData(prev => ({ ...prev, storeId }));
                                                    sessionStorage.setItem("currentStoreId", storeId);
                                                    window.dispatchEvent(new Event("storeChanged"));
                                                }}
                                            >
                                                <option value="">Select Branch</option>
                                                {stores
                                                    .filter(store =>
                                                        role === "SuperAdmin" ||
                                                        (role === "Admin" && adminStoreIds.includes(store._id))
                                                    )
                                                    .map(store => (
                                                        <option key={store._id} value={store._id}>
                                                            {store.storeName}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>
                                    </div>
                                    <div className='Booking-form-row'>
                                        <div className='booking-form-group'>
                                            <label htmlFor="appointmentDate" className="input-label">
                                                Appointment Date
                                            </label>
                                            <input
                                                type="date"
                                                className="booking-input"
                                                value={formData.appointmentDate ? formData.appointmentDate.toISOString().slice(0, 10) : ""}
                                                onChange={(e) =>
                                                    setFormData({
                                                        ...formData,
                                                        appointmentDate: new Date(e.target.value),
                                                    })
                                                }
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className='booking-form-group'>
                                            <label htmlFor="timeSlot" className="input-label">
                                                Time Slot
                                            </label>
                                            <input
                                                type="time"
                                                className="booking-input"
                                                value={formData.timeSlot ? formData.timeSlot.toISOString().slice(11, 16) : ""}
                                                onChange={(e) => {
                                                    const [hours, minutes] = e.target.value.split(":");
                                                    const updatedDate = formData.appointmentDate
                                                        ? new Date(formData.appointmentDate) // base on selected date
                                                        : new Date(); // fallback to today
                                                    updatedDate.setHours(hours, minutes);
                                                    setFormData({
                                                        ...formData,
                                                        timeSlot: updatedDate,
                                                    });
                                                }}
                                                disabled={loading}
                                            />
                                        </div>
                                        <div className="booking-form-group">
                                            <label className="input-label">Status</label>
                                            <select
                                                id="status"
                                                className="booking-input"
                                                required
                                                disabled={!formData.timeSlot || loading}
                                                value={formData.status}
                                                onChange={(e) => {
                                                    const selectedStatusType = e.target.value;
                                                    setFormData((prev) => ({ ...prev, status: selectedStatusType }))
                                                }}
                                            >
                                                <option value='' >Select status</option>
                                                <option value='Scheduled'>Scheduled</option>
                                                <option value='Completed'>Completed</option>
                                                <option value='Cancelled'>Cancelled</option>
                                                <option value='Pending'>Pending</option>
                                                <option value='In Progress'>In Progress</option>
                                                <option value='Rejected'>Rejected</option>
                                                <option value='Approved'>Approved</option>
                                            </select>
                                        </div>
                                    </div>
                                    <div className='Booking-form-row'>
                                        <div className='booking-form-group'>
                                            <label htmlFor="remarks" className="input-label">
                                                Remarks
                                            </label>
                                            <textarea
                                                placeholder="Enter Remarks"
                                                className="booking-input"
                                                value={formData.remarks || ""}
                                                onChange={e => {
                                                    let value = e.target.value;

                                                    // Auto bullet on Enter
                                                    if (value.endsWith("\n")) {
                                                        value += "• ";
                                                    }
                                                    setFormData(prev => ({ ...prev, remarks: value }));
                                                }}
                                                style={{ height: '100px' }}
                                                disabled={loading}
                                            />
                                        </div>
                                    </div>
                                    <div className="Booking-buttons">
                                        <button className="add-Booking-button" type="submit" onClick={handleAddBooking} disabled={loading}
                                        >
                                            {loading ? (
                                                <div className='loader'></div>
                                            ) : (
                                                "add Booking"
                                            )}
                                        </button>
                                        <button className="cancel-Booking-button" onClick={() => setIsAddBooking(false)} disabled={loading} >
                                            cancel
                                        </button>
                                    </div>
                                </form>
                            </div>

                        </div>
                    ) : (
                        <>
                            <div className="booking-widgets">
                                <div className="booking-widgets-header">
                                    <h3>Bookings</h3>
                                    <input
                                        type="text"
                                        placeholder="Search"
                                        className="booking-search-input"
                                        value={searchQuery}
                                        onChange={(e) => setSearchQuery(e.target.value)}
                                    />
                                </div>
                                <div className="add-booking-buttons">
                                    <button className="add-btn-booking" onClick={() => setIsAddBooking(true)} >+ Add New Booking</button>
                                </div>
                            </div>
                            <TableContainer component={Paper} sx={{
                                borderRadius: '12px',
                                maxHeight: 400,
                                overflowY: "auto",
                                '&::-webkit-scrollbar': { display: 'none' },
                                scrollbarWidth: 'none',
                                msOverflowStyle: 'none',
                            }}>
                                <Table className="custom-product-table"
                                    sx={{
                                        '& td, & th': {
                                            border: 'none',
                                        },
                                        border: 'none',
                                    }}>
                                    <TableHead className="custom-product-head">
                                        <TableRow>
                                            {headings.map((heading, index) => (
                                                <TableCell
                                                    key={index}
                                                    sx={{
                                                        border: 'none',
                                                        padding: '12px 16px',
                                                        textAlign: 'center',
                                                        textAlign: 'center',
                                                        position: "sticky",
                                                        top: 0,
                                                        backgroundColor: '#F7EAE2',
                                                        zIndex: 1,
                                                    }}
                                                >
                                                    <Typography
                                                        variant="body2"
                                                        sx={{
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            justifyContent: 'center',
                                                            gap: '4px',
                                                            color: '#000000',
                                                            fontSize: '14px',
                                                            fontWeight: 600,
                                                        }}
                                                    >
                                                        {heading}
                                                    </Typography>
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {bookings.length === 0 ? (
                                            <TableRow>
                                                <TableCell colSpan={5}>
                                                    <Typography sx={{ textAlign: 'center', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '20px', fontWeight: 500 }}>
                                                        No Bookings found.
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        ) : (
                                            bookings.map((booking, index) => (
                                                <TableRow key={booking._id}>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>{index + 1}</Typography>
                                                    </TableCell>
                                                    <TableCell><Typography sx={commonCellStyle}>{booking.CustomerDetails?.[0]?.name}</Typography></TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {booking.timeSlot
                                                                ? DateTime.fromISO(booking.timeSlot).toFormat("dd LLL yyyy, hh:mm a")
                                                                : "—"}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography sx={commonCellStyle}>
                                                            {booking.storeDetails?.[0]?.storeName}
                                                        </Typography>
                                                    </TableCell>
                                                    <TableCell>

                                                    </TableCell>
                                                    <TableCell>
                                                        {(() => {
                                                            const { label, bg, hover } = getStatusStyle(booking.status);
                                                            return (
                                                                <Button
                                                                    variant="contained"
                                                                    sx={{
                                                                        backgroundColor: bg,
                                                                        color: "#fff",
                                                                        fontWeight: 600,
                                                                        padding: "4px 8px",
                                                                        borderRadius: "20px",   // pill style
                                                                        width: "130px",
                                                                        textTransform: "none",
                                                                        "&:hover": { backgroundColor: hover },
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        justifyContent: "center",
                                                                        margin: "0 auto",
                                                                    }}
                                                                >
                                                                    {label}
                                                                </Button>
                                                            );
                                                        })()}
                                                    </TableCell>
                                                    <TableCell>
                                                        <Box sx={{ display: 'flex', gap: 3, alignItems: 'center', justifyContent: 'center' }}>
                                                            <Icon icon={plusIcon} width={20} height={20} />
                                                            <Icon icon={editIcon} width={20} height={20} style={{ cursor: "pointer" }} onClick={() => {
                                                                const appointmentDate = booking.appointmentDate
                                                                    ? new Date(booking.appointmentDate).toISOString().split("T")[0] // "2025-08-28"
                                                                    : "";

                                                                const timeSlot = booking.timeSlot
                                                                    ? new Date(booking.timeSlot).toISOString().substring(11, 16) // "16:03"
                                                                    : "";
                                                                setFormData({
                                                                    customerId: booking.customerId || '',
                                                                    serviceId: booking.serviceId || '',
                                                                    storeId: booking.storeId || '',
                                                                    appointmentDate,
                                                                    timeSlot,
                                                                    status: booking.status || '',
                                                                    remarks: booking.remarks || ''
                                                                });

                                                                setEditBookingId(booking._id);
                                                                setIsPopupMode(true);
                                                                setIsEditMode(true);
                                                            }} />
                                                            <Icon icon={deleteIcon} width={20} height={20} style={{ color: '#C10000' }}
                                                                onClick={() => handleOpen(booking._id)}
                                                            />
                                                        </Box>

                                                    </TableCell>
                                                </TableRow>

                                            ))
                                        )}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <div className="booking-bottom">
                                <div className="booking-section show-entries">
                                    <span className="text-label">Show</span>
                                    <select className="entries-select" value={limit}
                                        onChange={handleItemsPerPageChange}
                                    >
                                        <option value="5">5</option>
                                        <option value="10">10</option>
                                        <option value="25">25</option>
                                        <option value="all" >All</option>
                                    </select>
                                    <span className="text-label">Entries</span>
                                </div>
                                <div className="booking-section showing-range">
                                    {
                                        limit === 'all'
                                            ? `Showing all ${totalCount} entries`
                                            : `Showing ${(currentPage - 1) * limit + 1} to ${Math.min(currentPage * limit, totalCount)} of ${totalCount} entries`
                                    }
                                </div>
                                <div className="booking-section spacer"></div>
                                <div className="booking-section pagination-buttons">
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === 1}
                                        onClick={() => handlePageChange("prev")}
                                    >Previous</button>
                                    <button
                                        className="pagination-btn"
                                        disabled={currentPage === totalPages}
                                        onClick={() => handlePageChange("next")}
                                    >Next</button>
                                </div>
                            </div>
                            {
                                isPopupMode && (
                                    <div className='popup-overlay'>
                                        <div className="popup-wrapper">
                                            <Icon
                                                icon={closeIcon}
                                                className="popup-close-icon-outside"
                                                onClick={() => {
                                                    setIsPopupMode(false);
                                                    setIsEditMode(false);
                                                    setFormData({
                                                        customerId: "",
                                                        serviceId: "",
                                                        appointmentDate: "",
                                                        timeSlot: "",
                                                        status: "",
                                                        remarks: "",
                                                        storeId: "",
                                                    });
                                                }}
                                            />
                                            <div className="popup-form">
                                                <h2 className="popup-title">
                                                    {isEditMode ? "Edit Booking" : "Add Booking"}
                                                </h2>
                                                <div className='booking-form-container'></div>
                                                {loading && <div className="form-blocker"></div>}
                                                <form className="popup-form-body" onSubmit={handleUpdateBooking}>
                                                    <div className="form-group-row">
                                                        <div className="form-group">
                                                            <label htmlFor="title" className="input-label">
                                                                Customer Name
                                                            </label>
                                                            <select
                                                                id="customerId"
                                                                className="booking-input"
                                                                required
                                                                value={formData.customerId}
                                                                disabled={loading}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, customerId: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select Customer</option>
                                                                {customers.map((cus) => (
                                                                    <option key={cus._id} value={cus._id}>
                                                                        {cus.name}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="input-label">Branch Name</label>
                                                            <select
                                                                className="category-input"
                                                                value={formData.storeId || ""}
                                                                onChange={(e) =>
                                                                    setFormData(prev => ({ ...prev, storeId: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select Branch</option>
                                                                {stores
                                                                    .filter(store =>
                                                                        role === "SuperAdmin" ||
                                                                        (role === "Admin" && JSON.parse(sessionStorage.getItem("storeIds") || "[]").includes(store._id))
                                                                    )
                                                                    .map(store => (
                                                                        <option key={store._id} value={store._id}>
                                                                            {store.storeName}
                                                                        </option>
                                                                    ))}
                                                            </select>
                                                        </div>
                                                        <div className='form-group'>
                                                            <label htmlFor="title" className="input-label">
                                                                Service Name
                                                            </label>
                                                            <select
                                                                id="serviceId"
                                                                className="booking-input"
                                                                required
                                                                value={formData.serviceId}
                                                                disabled={loading}
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({ ...prev, serviceId: e.target.value }))
                                                                }
                                                            >
                                                                <option value="">Select Service</option>
                                                                {services.map((ser) => (
                                                                    <option key={ser._id} value={ser._id}>
                                                                        {ser.serviceName}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </div>

                                                    </div>
                                                    <div className="form-group-row">
                                                        <div className='form-group'>
                                                            <label htmlFor="appointmentDate" className="input-label">
                                                                Appointment Date
                                                            </label>
                                                            <input
                                                                type="date"
                                                                className="booking-input"
                                                                value={formData.appointmentDate || ""}
                                                                disabled={loading}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, appointmentDate: e.target.value })
                                                                }
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label htmlFor="timeSlot" className="input-label">
                                                                Time Slot
                                                            </label>
                                                            <input
                                                                type="time"
                                                                className="booking-input"
                                                                value={formData.timeSlot || ""}
                                                                disabled={loading}
                                                                onChange={(e) =>
                                                                    setFormData({ ...formData, timeSlot: e.target.value })
                                                                }
                                                            />
                                                        </div>
                                                        <div className="form-group">
                                                            <label className="input-label">Status</label>
                                                            <select
                                                                id="status"
                                                                className="booking-input"
                                                                required
                                                                value={formData.status}
                                                                disabled={loading}
                                                                onChange={(e) => {
                                                                    const selectedStatusType = e.target.value;
                                                                    setFormData((prev) => ({ ...prev, status: selectedStatusType }))
                                                                }}
                                                            >
                                                                <option value='' >Select status</option>
                                                                <option value='Scheduled'>Scheduled</option>
                                                                <option value='Completed'>Completed</option>
                                                                <option value='Cancelled'>Cancelled</option>
                                                                <option value='Pending'>Pending</option>
                                                                <option value='In Progress'>In Progress</option>
                                                                <option value='Rejected'>Rejected</option>
                                                                <option value='Approved'>Approved</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div className="form-actions">
                                                        <button type="submit" className="btn-primary" disabled={loading}>
                                                            {loading ?
                                                                (
                                                                    <div className='loader'></div>
                                                                ) : (
                                                                    isEditMode ? "Update Booking" : "Add Booking"
                                                                )
                                                            }

                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="btn-secondary"
                                                            onClick={() => setIsPopupMode(false)}
                                                            disabled={loading}
                                                        >
                                                            Cancel
                                                        </button>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                )
                            }
                            {limit > 5 && bookings.length > 5 && (
                                <div className="scroll-down-hint">
                                    <Typography sx={{ display: 'flex', justifyContent: 'center', marginTop: 2, fontSize: 14, fontWeight: 600 }}>
                                        Scroll down to see more Bookings
                                    </Typography>
                                </div>
                            )}
                            <Modal
                                open={open}
                                onClose={handleClose}
                                aria-labelledby="modal-modal-title"
                                aria-describedby="modal-modal-description"
                            >
                                <Box sx={modalStyle}>
                                    <Typography id="modal-modal-title" variant="h6" component="h2" sx={{ textAlign: 'center' }}>
                                        Confirm Delete?
                                    </Typography>
                                    <Typography id="modal-modal-description" sx={{ mt: 1, fontSize: 14, textAlign: 'center' }}>
                                        Are you sure you want to delete this Booking?
                                    </Typography>

                                    <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2, mt: 3 }}>
                                        <Button variant="contained" color="error" sx={{ background: 'linear-gradient(#A16A70, #D98484)' }} onClick={handleDeleteBooking}>
                                            Yes, Delete
                                        </Button>
                                        <Button variant="outlined" color="error" onClick={handleClose} sx={{ background: 'background-color: #D9D9D9', color: '#000' }}>
                                            Cancel
                                        </Button>
                                    </Box>
                                </Box>
                            </Modal>
                        </>
                    )}
                </main>
            </div>
        </div >
    );
};

export default BookingPage;